module.exports = __webpack_public_path__ + "menu_3_pc.bac89391.png";